import { setUser as setDataDogUser } from '@eb/real-user-monitoring';

import { UserAction, UserActionType } from '../actions/user';
import { UserNamespace } from '../state/user';

export const userReducer = (
    state: UserNamespace = {
        userInstruments: [],
        hasPassword: false,
        hasSocialLogin: false,
    },
    action: UserAction,
): UserNamespace => {
    switch (action.type) {
        case UserActionType.initializeUser:
            setDataDogUser({
                id: action.payload?.publicId,
                name: action.payload?.fullName,
                email: action.payload?.email,
            });

            return {
                ...state,
                ...(action.payload ?? {}),
            };
        case UserActionType.updateUserInstruments:
            return {
                ...state,
                userInstruments: action.payload,
            };

        case UserActionType.setVirtualIncentive:
            return {
                ...state,
                virtualIncentive: action.payload,
            };

        case UserActionType.setUserAsLoggedIn:
            setDataDogUser({
                id: action.payload.publicId,
                name: action.payload.fullName,
                email: action.payload.email,
            });

            return {
                ...state,
                ...action.payload,
            };
        case UserActionType.setUserSiginInMethods:
            return {
                ...state,
                ...action.payload,
            };
        case UserActionType.clearUserData:
            setDataDogUser({});

            return {
                userInstruments: [],
                hasPassword: false,
                hasSocialLogin: false,
            };

        default:
            return state;
    }
};
